import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { AppID, Environment, SpaceID } from '@playq/octopus-common';
import { AppPromotions, PromotionSource } from '@playq/octopus2-apps-utility';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';
import { createPromotionSource } from '/helpers';
import { appToolkit } from '/store';

export const useAppSpacePromotions = (
  id?: SpaceID | Environment,
  options?: IUseQueryOptionsExtended<AppPromotions | undefined, GenericFailure | Error>
) => {
  const appID = useSelector(appToolkit.selectors.appID);

  const keys = [
    'spacesPromotionsService',
    'appPromotions',
    appID?.company,
    appID?.id,
    id instanceof SpaceID ? id.id : id,
  ];

  const source = useMemo(() => createPromotionSource(id), [id]);

  return useEitherQuery(
    keys,
    () => services2.spacesPromotionsService.appPromotions(appID as AppID, source as PromotionSource),
    {
      ...options,
      enabled: options?.enabled !== false && source !== undefined,
    }
  );
};
